module.exports = __webpack_public_path__ + "static/media/light_dataak_logo.129672aa.svg";